import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translations from './translations';

// Get saved language or default to English
const savedLang = localStorage.getItem('language') || 'en';

i18n
  .use(initReactI18next)
  .init({
    resources: translations,
    lng: savedLang,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
